// This file is auto-generated after CDK deployment
const awsmobile = {
  "aws_project_region": "us-east-1",
  "aws_cognito_identity_pool_id": "us-east-1:d7ac6d84-6574-4394-b9ce-fe3043e0b751",
  "aws_cognito_region": "us-east-1",
  "aws_user_pools_id": "us-east-1_UzA5dN225",
  "aws_user_pools_web_client_id": "798kg69nspdnulsnlsm9r8b673",
  "aws_user_files_s3_bucket": "nightbaconstack-nightbaconstoragebucketa76ef349-fmcrtuidnicn",
  "aws_user_files_s3_bucket_region": "us-east-1",
  "aws_cloud_front_url": "d364yrwgxgqdfg.cloudfront.net",
  "api": {
    "endpoints": [
      {
        "name": "NightBaconAPI",
        "endpoint": "https://f8r84a0hqe.execute-api.us-east-1.amazonaws.com/prod/"
      }
    ]
  }
};

export default awsmobile;
